export async function useConfirmationPage() {
    const route = useRoute()
    const orderId = route.query.orderId
    const {data} = await useAsyncData(`confirmation-${orderId}`, async () => {
        try {
            const {
                orders: [
                    {
                        services: [
                            {
                                travelers: [tourlead],
                            },
                        ],
                    },
                ],
            } = await appInstance.$api.orders.get({orderId, responseType: 'SHORT', orderType: 'TA'})
            return {tourlead}
        } catch (e) {
            console.error(e)
            return {tourlead: null}
        }
    })
    return data.value
}
